import React, { useEffect } from 'react';
import { Box, useColorMode } from '@chakra-ui/react';
import { Route, Switch, useLocation } from 'react-router-dom';
import Site from 'views/Site/Site';
import SiteHeader from 'views/Site/components/SiteHeader';
import SiteFooter from 'views/Site/components/SiteFooter';
import IntegrationsIndex from 'views/Site/IntegrationsIndex';
import IntegrationPage from 'views/Site/IntegrationPage';

// Public layout cho `/` — landing page marketing.
// KHÔNG yêu cầu đăng nhập, cố định light mode để landing nhất quán.
export default function SiteLayout() {
  const { setColorMode } = useColorMode();
  const location = useLocation();

  useEffect(() => {
    setColorMode('light');
    document.body.style.overflow = 'unset';
  }, [setColorMode]);

  useEffect(() => {
    if (!window.location.hash) window.scrollTo({ top: 0, behavior: 'auto' });
  }, [location.pathname]);

  return (
    <Box minH="100vh" bg="white" display="flex" flexDirection="column">
      <SiteHeader />
      <Box as="main" flex={1}>
        <Switch>
          <Route exact path="/" component={Site} />
          <Route exact path="/integrations" component={IntegrationsIndex} />
          <Route exact path="/integrations/:slug" component={IntegrationPage} />
        </Switch>
      </Box>
      <SiteFooter />
    </Box>
  );
}
